export default __webpack_public_path__ + "static/media/price_group.49fdd6b6.svg";